<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string
    toggleStatus?: boolean
  }>(),
  { toggleStatus: false }
)

const isOpen = ref(props.toggleStatus)

const toggle = () => {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div>
    <a
      class="
        mb-3 block text-base font-medium leading-6 tracking-tight text-main-dark !no-underline hover:text-main-green
      "
      href="#"
      @click.prevent="toggle"
    >
      {{ title }}
    </a>

    <transition name="fade">
      <div v-if="isOpen" class="mt-2">
        <slot />
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
